module.exports = __webpack_public_path__ + "static/img/DM.1b29942a.png";